import React, { useEffect, createElement, Component } from 'react';
import { useLocation } from 'react-router-dom';
// Definición de tipos para el Meta Pixel
declare global {
  interface Window {
    fbq: any;
  }
}
// ID de tu Pixel de Facebook
const PIXEL_ID = '286333876857444'; // ID real del Meta Pixel
// Inicialización del Pixel
export const initializePixel = () => {
  if (typeof window !== 'undefined') {
    // Evita duplicar la inicialización
    if (!window.fbq) {
      window.fbq = function () {
        // @ts-ignore
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      if (!window.fbq.queue) {
        window.fbq.queue = [];
      }
      // Insertar el script de Facebook Pixel
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Inicializar el Pixel
      window.fbq('init', PIXEL_ID);
    }
  }
};
// Evento de vista de página
export const trackPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};
// Evento de vista de contenido (producto)
export const trackViewContent = (productData = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'ViewContent', {
      content_name: 'Corona de Alivio 360',
      content_category: 'Salud y Bienestar',
      content_ids: ['CORONA360'],
      content_type: 'product',
      value: 25.0,
      currency: 'USD',
      ...productData
    });
  }
};
// Evento de inicio de checkout
export const trackInitiateCheckout = (productData = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'Corona de Alivio 360',
      content_ids: ['CORONA360'],
      content_type: 'product',
      value: 25.0,
      currency: 'USD',
      num_items: 1,
      ...productData
    });
  }
};
// Evento de clic en CTA principal
export const trackAddToCart = (productData = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Corona de Alivio 360',
      content_ids: ['CORONA360'],
      content_type: 'product',
      value: 25.0,
      currency: 'USD',
      ...productData
    });
  }
};
// Evento de compra completada
export const trackPurchase = (purchaseData = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Purchase', {
      content_name: 'Corona de Alivio 360',
      content_ids: ['CORONA360'],
      content_type: 'product',
      value: 25.0,
      currency: 'USD',
      ...purchaseData
    });
  }
};
// Evento de lead (formulario enviado)
export const trackLead = (leadData = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: 'Corona de Alivio 360',
      content_category: 'Salud y Bienestar',
      ...leadData
    });
  }
};
// Componente que inicializa el Pixel y rastrea cambios de página
const MetaPixel = () => {
  const location = useLocation();
  useEffect(() => {
    // Inicializar el Pixel al montar el componente
    initializePixel();
    // Rastrear la vista de página inicial
    trackPageView();
    // Rastrear vista de contenido del producto
    trackViewContent();
  }, []);
  // Rastrear cambios de página
  useEffect(() => {
    trackPageView();
  }, [location.pathname]);
  return null; // Este componente no renderiza nada visible
};
export default MetaPixel;